import React from 'react';
import { Box, Heading, Text } from '@wix/design-system';
import clsx from 'clsx';
import styles from './ProgressLoader.scss';
export function ProgressLoaderHeader(_ref) {
  let {
    title,
    subtitle,
    className,
    titleClassName,
    subtitleClassName
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "8px",
    align: "center",
    className: className
  }, /*#__PURE__*/React.createElement(Heading, {
    size: "large",
    className: clsx(styles.title, titleClassName)
  }, title), subtitle && /*#__PURE__*/React.createElement(Text, {
    size: "medium",
    secondary: true,
    className: clsx(styles.subtitle, subtitleClassName)
  }, subtitle));
}
//# sourceMappingURL=ProgressLoaderHeader.js.map